export const blockIconsFileDriveFileRenameOutline = (
	<span className='material-symbols-outlined'>drive_file_rename_outline</span>
);
